import { setAccessToken } from './token'

export interface WebTokenResponse {
  access_token: string
  token_type: 'bearer'
  access_expires_at: string
  refresh_expires_at: string
}

export interface OtpChallenge {
  challenge_id: string
  expires_at: string
  delivery: 'local' | 'provider'
  dev_code?: string | null
}

async function jsonRequest<T>(url: string, body?: unknown): Promise<T> {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  const payload = (await response.json()) as
    T | { error?: { message?: string } }
  if (!response.ok) {
    const message =
      'error' in (payload as object)
        ? (payload as { error?: { message?: string } }).error?.message
        : undefined
    throw new Error(message ?? `Request failed (${response.status})`)
  }
  return payload as T
}

export function requestOtp(phone: string, audience: 'customer' | 'ops') {
  return jsonRequest<OtpChallenge>('/auth/web/otp/request', { phone, audience })
}

export async function verifyOtp(challengeId: string, code: string) {
  const tokens = await jsonRequest<WebTokenResponse>('/auth/web/otp/verify', {
    challenge_id: challengeId,
    code,
  })
  setAccessToken(tokens.access_token)
  return tokens
}

export async function refreshSession() {
  const tokens = await jsonRequest<WebTokenResponse>('/auth/web/refresh')
  setAccessToken(tokens.access_token)
  return tokens
}

export async function logoutSession() {
  try {
    await jsonRequest<{ message: string }>('/auth/web/logout')
  } finally {
    setAccessToken(null)
  }
}
